import { useParams } from 'react-router-dom';

import type { RouteParams } from '../configs/route.config';
import useSearchParams from './useSearchParams';

type CurrentContext = {
  organizationsId?: string;
  hubsId?: string;
  fleetsId?: string;
};

const useUrlContext = (): {
  urlContext: CurrentContext;
  isContextAvailable: boolean;
} => {
  const params = useParams<RouteParams>();
  const searchParams = useSearchParams();
  const urlContext = {
    organizationsId: searchParams.organizationsId ?? params.organizationsId,
    hubsId: searchParams.hubsId ?? params.hubsId,
    fleetsId: searchParams.fleetsId ?? params.fleetsId,
  };

  const isContextAvailable = Object.values(urlContext).some((value) => !!value);

  return { urlContext, isContextAvailable };
};

export default useUrlContext;
